import {MarketsTable} from '@/components/MarketsTable'
import {AddCountryModal} from '@/components/MarketsTable/AddCountryModal'
import {PrimaryButton} from '@/shared-components/Button'
import {PageHeader} from '@/shared-components/PageHeader'
import {useState} from 'react'
import {useIntl} from 'react-intl'
import {PageContent} from './Template/components/PageContent'

export const MarketsPage = () => {
  const {formatMessage} = useIntl()
  const [isAddCountryModalOpen, setIsAddCountryModalOpen] = useState(false)

  return (
    <PageContent data-testid="markets-page" pageContentWrapperClassName="relative">
      <div className="mb-6">
        <PageHeader title={formatMessage({id: 'MARKETS.TITLE'})} className="relative justify-start" />

        <div className="mt-2 flex items-start gap-4 text-base" data-testid="subtitle-content">
          <div className="subtitle flex-1 text-sm text-text-secondary">{formatMessage({id: 'MARKETS.SUBTITLE'})}</div>

          <div className="button-container ml-auto flex gap-4">
            <PrimaryButton
              iconTrailing="add"
              size="small"
              data-cy="button-add-country"
              data-testid="button-add-country"
              onClick={() => setIsAddCountryModalOpen(true)}
            >
              {formatMessage({id: 'MARKETS.ADD_COUNTRY_BUTTON'})}
            </PrimaryButton>
          </div>
        </div>
      </div>
      <MarketsTable />
      <AddCountryModal isOpen={isAddCountryModalOpen} onClose={() => setIsAddCountryModalOpen(false)} />
    </PageContent>
  )
}
